
<style lang="stylus" scoped>
@import '../css/var'
.container
  display flex
  background #FFF9C4
  padding  pt(25)
  align-items center
.title
  color #f44336
  font-size pt(30)
.iconsize
  margin-right 9px
  color #f44336
  font-size pt(50)
</style>
<template>
<div class="container">
  <i class="icon iconsize">&#xe6bf;</i>
  <div class="title">
    {{titleText}}
  </div>
</div>
</template>
<script>
export default {
  props: {
    titleText: ''
  }
}
</script>


// WEBPACK FOOTER //
// foxconn.vue?a006f99a